import { apiUrlNotification } from "~constants";
import Network from "~helpers/Network";

import * as at from "./actionTypes";
/**
 * @param {boolean} silentEnable Register push notifications services if user is already allowed to browser
 *   notifications.
 */
export const requestPushNotification = (silentEnable) => ({
  type: at.REQUEST_PUSH_NOTIFICATION,
  payload: silentEnable,
});

export const clearPushNotification = () => ({
  type: at.CLEAR_PUSH_NOTIFICATION,
});

export const setNotifications = (payload) => ({
  type: at.SET_NOTIFICATIONS,
  payload,
});

export const setNotificationPreferences = (payload) => ({
  type: at.SET_NOTIFICATION_PREFERENCES,
  payload,
});

export const setIsNotificationRequesting = (status) => ({
  type: at.SET_IS_NOTIFICATION_REQUESTING,
  payload: status,
});

// ------------- API -------------

export const getNotifications = (params) => (_dispatch) => {
  return Network.request(apiUrlNotification.get, {
    // loading: true,
    params,
    onSuccess: setNotifications,
  });
};

export const markAsReadNotifications =
  (idList = []) =>
  (_dispatch) => {
    return Network.request(apiUrlNotification.get, {
      method: "POST",
      loading: true,
      params: {
        seen: idList.join(","),
      },
    });
  };

export const getNotificationPreferences =
  (options = {}) =>
  (_dispatch) => {
    return Network.request(apiUrlNotification.getNotificationPreference, {
      method: "GET",
      loading: true,
      successMsg: false,
      onSuccess: (response) => setNotificationPreferences(response?.results),
      ...options,
    });
  };

export const setSeenNotificationStatus = (data) => (_dispatch, _getState) => {
  return Network.request(apiUrlNotification.updateNotificationAction, {
    method: "POST",
    data,
    loading: true,
    successMsg: true,
  });
};

export const createNotificationPreference = (data) => (_dispatch, _getState) => {
  return Network.request(apiUrlNotification.getNotificationPreference, {
    method: "POST",
    data,
    loading: true,
    successMsg: true,
  });
};
export const deleteNotificationPreference = (id) => (_dispatch, _getState) => {
  return Network.request(`${apiUrlNotification.getNotificationPreference}${id}/`, {
    method: "DELETE",
    loading: true,
    successMsg: true,
  });
};

export const sendTestPushNotification = (dynamicKeyValueObj) => (_dispatch, _getState) => {
  return Network.request(apiUrlNotification.getTest, {
    method: "POST",
    data: {
      ...dynamicKeyValueObj,
    },
    loading: true,
    successMsg: true,
  });
};
